export const UserRole = {
    SUPER_ADMINISTRATOR: 'SuperAdministrator',
    ADMINISTRATION: 'Administration',
    REGIONAL_DIRECTOR: 'Regional Director',
    SHIFT_LEAD: 'Shift Lead',
    ASSISTANT_MANAGER: 'Assistant Manager',
    HOUSE_MANAGER: 'House Manager',
    PROGRAM_MANAGER: 'Program Manager',
    CLIENT_SERVICES_MANAGER: 'Client Services Manager',
    MEDICAL_MANAGER: 'Medical Manager',
    FINANCE_MANAGER: 'Finance Manager',
    COMPLIANCE_MANAGER: 'Compliance Manager',
    PROGRAM_COORDINATOR: 'Program Coordinator',
    HUMAN_RESOURCES: 'Human Resources',
    HUMAN_RESOURCES_ASSISTANT: 'Human Resources Assistant',
    PARENT_GUARDIAN: 'Parent/Guardian',
    SUPPORT_COORDINATOR: 'Support Coordinator',
    CLIENT: 'Client',
    PHARMACY: 'Pharmacy',
    DIRECT_CARE_STAFF: 'Direct Care Staff',
    AUDITOR: 'Auditor'
};
